import React from 'react';
import { ThemeProvider, Theme, GlobalStyles } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import defaultTheme from './defaultTheme';

const navCssVars = {
  ':root': {
    '--nav-rail-width': '68px',
    '--nav-subpanel-width': '240px',
    '--nav-tab-pill-width': '52px',
    '--nav-radius-sm': '4px',
  },
};

interface AppThemeProviderProps {
  children: React.ReactNode;
  theme?: Theme;
}

const AppThemeProvider = ({ children, theme = defaultTheme }: AppThemeProviderProps) => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <GlobalStyles styles={navCssVars} />
    {children}
  </ThemeProvider>
);

export default AppThemeProvider;
